import React, { useEffect, useRef, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add'
import { motion, AnimatePresence } from "motion/react"
import { OverlayTrigger, Popover, Overlay, Modal, Toast, Offcanvas, Accordion } from 'react-bootstrap'
import Select from 'react-select'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import dayjs from 'dayjs'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import FormControl from '@mui/material/FormControl';
import { filesize } from "filesize"
import { emphasize, styled } from '@mui/material/styles'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Chip from '@mui/material/Chip'
import HomeIcon from '@mui/icons-material/Home'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import 'react-calendar/dist/Calendar.css'
import { saveAs } from "file-saver"
import DownloadingIcon from '@mui/icons-material/Downloading'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import MovieIcon from '@mui/icons-material/Movie'
import PermMediaIcon from '@mui/icons-material/PermMedia'
import AudiotrackIcon from '@mui/icons-material/Audiotrack'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import VideoFileIcon from '@mui/icons-material/VideoFile'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


import RichTextEditor from 'react-rte'
import InputBase from '@mui/material/InputBase'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import RTE from './RTE'
import { ConfigProvider, Pagination } from "antd";
import CustomSpinner from '../../components/CustomSpinner';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />


function Ticket({ serverURL, user, setShowSideOverlay, socket, logToUse, setLogToUse }) {
    const [addYoutubeVideoShow, setAddYoutubeVideoShow] = useState(false)
    const [videoAdded, setVideoAdded] = useState(false)
    const [currentPageNumber, setCurrentPageNumber] = useState(1)
    const [tags, setTags] = useState(null)

    const [chosenDateFilter, setChosenDateFilter] = useState(null)

    const urlRef = useRef("")
    const StyledBreadcrumb = styled(Chip)(({ theme }) => {
        const backgroundColor =
            theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[800];
        return {
            backgroundColor,
            height: theme.spacing(3),
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightRegular,
            '&:hover, &:focus': {
                backgroundColor: emphasize(backgroundColor, 0.06),
            },
            '&:active': {
                boxShadow: theme.shadows[1],
                backgroundColor: emphasize(backgroundColor, 0.12),
            },
        };
    })


    const [allTicketsFromEmail, setAllTicketsFromEmail] = useState(null)

    const [showAttachmentPreview, setShowAttachmentPreview] = useState(false)
    const [attachmentToUse, setAttachmentToUse] = useState(null)

    const [ticketStatus, setTicketStatus] = useState(null)

    const [showAddNewTicket, setShowAddNewTicket] = useState(false)
    const [statusChanger, setStatusChanger] = useState(false)
    const [ticketToUse, setTicketToUse] = useState(null)

    const [assgnedTo, setAssgnedTo] = useState(null)
    const [assignedToOptions, setAssignedToOptions] = useState(null)


    const [showLogs, setShowLogs] = useState(false)

    const [ticketCreated, setTicketCreated] = useState(false)
    const [statusChanged, setStatusChanged] = useState(false)

    const [lastTicket, setLastTicket] = useState(1)
    const [lastMailTicketNumber, setLastMailTicketNumber] = useState(null)

    const [showToast, setShowToast] = useState(false)
    const [toastType, setToastType] = useState(null)
    const [toastTitle, setToastTitle] = useState(null)
    const [toastMessage, setToastMessage] = useState(null)


    const [statusFilter, setStatusFilter] = useState({ "label": "All Unresolved", "value": "Unresolved" })
    const [priorityFilter, setPriorityFilter] = useState(null)
    const [assignedToFilter, setAssignedToFilter] = useState(null)


    const [isDataChanged, setIsDataChanged] = useState({ "status": false, "assignedment": false, "comments": false, "deadline": false })


    const dakiyaRef = useRef()
    const [ticketSubjectRef, setticketSubjectRef] = useState("")
    const [ticketCategoryRef, setticketCategoryRef] = useState({ "label": "General", "value": "general" })
    const [deadlineRef, setdeadlineRef] = useState(null)
    const [studentIdRef, setstudentIdRef] = useState("")
    const [attachmentRef, setattachmentRef] = useState([])
    const [ticketStatusRef, setticketStatusRef] = useState({
        "label": "Open",
        "value": "open"
    })
    const [descriptionRef, setdescriptionRef] = useState("")
    const [ticketDepartmentRef, setticketDepartmentRef] = useState(null)
    const [ticketSubDepartmentRef, setticketSubDepartmentRef] = useState(null)
    const [ticketBranchRef, setticketBranchRef] = useState(null)
    const [ticketPriorityRef, setticketPriorityRef] = useState(null)
    const [ticketUserRef, setticketUserRef] = useState("")

    const [allDirectors, setAllDirectors] = useState([])
    const [allDesignations, setAllDesignations] = useState([])
    const [allDepartments, setAllDepartments] = useState([])
    const [allSubDepartments, setAllSubDepartments] = useState([])
    const [allUsers, setAllUsers] = useState([])
    const [allBranch, setAllBranch] = useState([])

    const [reportingManagerOptions, setReportingManagerOptions] = useState(null)
    const [departmentOptions, setdepartmentOptions] = useState(null)
    const [subDepartmentOptions, setSubDepartmentOptions] = useState(null)
    const [ticketOptions, setTicketOptions] = useState(null)
    const [branchOptions, setBranchOptions] = useState([
        {
            "value": "20",
            "label": "Bangalore Hebbal"
        },
        {
            "value": "5",
            "label": "Bangalore-BTM"
        },
        {
            "value": "6",
            "label": "Bangalore-Indiranagar"
        },
        {
            "value": "4",
            "label": "Chandigarh"
        },
        {
            "value": "7",
            "label": "Chennai"
        },
        {
            "value": "13",
            "label": "Delhi"
        },
        {
            "value": "11",
            "label": "Dubai"
        },
        {
            "value": "2",
            "label": "Faridabad"
        },
        {
            "value": "1",
            "label": "Gurugram"
        },
        {
            "value": "14",
            "label": "Hyderabad"
        },
        {
            "value": "23",
            "label": "Jaipur"
        },
        {
            "value": "22",
            "label": "Lucknow"
        },
        {
            "value": "21",
            "label": "Mangalore"
        },
        {
            "value": "18",
            "label": "MDWI India"
        },
        {
            "value": "8",
            "label": "Mumbai-Andheri"
        },
        {
            "value": "9",
            "label": "Navi Mumbai"
        },
        {
            "value": "12",
            "label": "Noida"
        },
        {
            "value": "19",
            "label": "Opportunity Card"
        },
        {
            "value": "17",
            "label": "Other"
        },
        {
            "value": "10",
            "label": "Pune"
        },
        {
            "value": "16",
            "label": "Test Branch"
        },
        {
            "value": "15",
            "label": "Vocational"
        },
    ])

    const [branchFilter, setBranchFilter] = useState([])


    const [globleSearchValues, setGlobleSearchValues] = useState(null)


    const [selectedUser, setSelectedUser] = useState(null)
    const [userOptions, setUserOptions] = useState([])

    const [allTicket, setAllTicket] = useState([])

    const [currentPageToken, setCurrentPageToken] = useState(null)

    const [loadingNewEmails, setLoadingNewEmails] = useState(false)


    const [editorContent, setEditorContent] = useState(null)
    const [logDescEditorContent, setLogDescEditorContent] = useState(null)


    const [allUsersMail, setAllUsersMail] = useState(null)

    const [loadingEntries, setLoadingEntries] = useState(true);

    const [entriesLimit, setEntriesLimit] = useState(100)
    const [skipEntries, setSkipEntries] = useState(0)
    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const [allMails, setAllMails] = useState(null)
    const [toDomains, settoDomains] = useState(null)
    const [fromDomains, setfromDomains] = useState(null)
    const [dataWithDate, setDataWithDate] = useState(null)
    const [showCalendarFollowup, setShowCalendarFollowup] = useState(false)
    const [showCalendarDeadline, setShowCalendarDeadline] = useState(false)


    const [mailAttachments, setMailAttachments] = useState(null)

    const [followDate, setFollowDate] = useState(new Date())
    const [deadlineDate, setDeadlineDate] = useState(new Date())

    const [selectedLabel, setSelectedLabel] = useState(null)

    const [myMessage, setMyMessage] = useState(null)
    const [showMyMessage, setShowMyMessage] = useState(false)

    const [selectedType, setSelectedType] = useState({ "label": "Pending", "value": "Pending" })
    const [isPriorityRequired, setIsPriorityRequired] = useState(false)
    const [priority, setPriority] = useState(null)
    const [isStatusRequired, setIsStatusRequired] = useState(false)
    const [status, setStatus] = useState(null)

    const [isCategoryRequired, setIsCategoryRequired] = useState(false)
    const [categryOption, setCategoryOption] = useState(null)

    const [isCategoryOptionRequired, setIsCategoryOptionRequired] = useState(false)
    const [selectedCategoryOption, setSelectedCategoryOption] = useState(null)

    const [remarks, setRemarks] = useState(null)
    const [isRemarRequired, setIsRemarRequired] = useState(false)


    const [ticketStatusOptions, setTicketStatusOptions] = useState(null)

    const [allAutomationRules, setAllAutomationRules] = useState(null)
    const [allAutomationRulesReady, setAllAutomationRulesReady] = useState(false)


    const getAllDepartments = async () => {
        const getDisticsDepartment = await axios.post(serverURL + "/forms/getAnimals")
        if (getDisticsDepartment.status === 200) {
            // console.log(getDisticsDepartment.data)
            setAllDepartments(getDisticsDepartment.data.departments)
            setAllSubDepartments(getDisticsDepartment.data.subDepartments)

            let departmentListings = getDisticsDepartment.data.departments.map((depart, key) => {
                return { "label": depart, "value": depart }
            })
            // console.log(departmentListings)

            setdepartmentOptions(departmentListings)

            let subDepartmentListings = getDisticsDepartment.data.subDepartments.map((subDep, key) => {
                return { "label": subDep.subDepartmnet, "value": subDep.subDepartmnet, "department": subDep.department }
            })

            // console.log(subDepartmentListings)

            setSubDepartmentOptions(subDepartmentListings)


            let userListings = []

            getDisticsDepartment.data.users.map((userData, key) => {
                return userListings.push({ "label": userData.submittedData["Employee Name"], "value": userData.submittedData["Official Mail Id"], "department": userData.submittedData["Process / Department"], "subDepartment": userData.submittedData["Sub Department"], "otherData": userData.submittedData })
            })

            // console.log(userListings)



            setUserOptions(userListings)

            setAssignedToOptions(userListings)


        } else {
            console.log(getDisticsDepartment.data)
        }
    }


    const convertToBase64 = (file) => {
        console.log(file)

        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    }

    const createTicketNow = async (e) => {
        e.preventDefault()

        let attachments = []

        const masterTiccketUID = uuidv4()
        let finalTagsFormat = []

        if (tags) {
            let filteredMentions = tags.filter((person) => { return person.id !== String(user.email).toLowerCase() && person.id !== String(ticketUserRef.value).toLowerCase() })

            filteredMentions.map((person, key) => {
                if (finalTagsFormat.includes(JSON.stringify(person))) {
                    return
                } else {
                    return finalTagsFormat.push(JSON.stringify(person))
                }
            })
        }



        if (attachmentRef.length > 0) {
            console.log("attached")


            for (let counter = 0; counter < attachmentRef.length; counter++) {
                await convertToBase64(attachmentRef[counter]).then((result) => {
                    attachments.push({
                        "fileData": result,
                        "uid": uuidv4(),
                        "name": attachmentRef[counter].name,
                        "type": attachmentRef[counter].type,
                        "size": attachmentRef[counter].size
                    })
                }).catch((err) => {
                    console.log(err)
                })
            }




            // console.log(attachments)

            const query = {
                "uid": masterTiccketUID,
                "ticketCategory": ticketCategoryRef,
                "ticketNumber": lastTicket,
                "status": ticketStatusRef,
                "subject": ticketSubjectRef,
                "department": ticketDepartmentRef,
                "subDepartment": ticketSubDepartmentRef,
                "createdBy": { "name": user.name, "email": user.email, "uid": user.uid, "reportingManager": user.manager },
                "raisedTo": ticketUserRef,
                "description": editorContent,
                "attachments": attachments,
                "priority": ticketPriorityRef,
                "studentId": studentIdRef,
                "assignedBranch": ticketBranchRef,
                "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY"),
                "overdue": {},
                "assignedStatus": {},
                "assignedTo": {},
                "escalationTo": {},
                "tags": finalTagsFormat,
                "logs": [{
                    "updatedByName": user.name,
                    "updatedByEmail": user.email,
                    "changed": `${user.name} created a new ticket`,
                    "description": editorContent,
                    "updatedOn": dayjs().valueOf()
                }]
            }

            const createNewTicket = await axios.post(serverURL + "/tickets/create", query)
            if (createNewTicket.status === 200) {
                // console.log(createNewTicket.data)
                e.target.reset()

                // ############################### Send Notifications To Tagged Person ############################################### 
                console.log(finalTagsFormat)

                const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "memebers": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

                if (sendTaggedEmailsToMentionedPeople.status === 200) {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                } else {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                }

                socket.emit("ticketRaised", { "admin": user.email, "mentions": finalTagsFormat })
                setTags(null)
                // ############################### End Notifications To Tagged Person ###############################################
                setAllTicket([createNewTicket.data, ...allTicket])
                setLastTicket(lastTicket)

                // setticketCategoryRef(null)
                setticketSubjectRef("")
                setticketDepartmentRef(null)
                setticketSubDepartmentRef(null)
                setticketUserRef(null)
                setdescriptionRef("")
                setattachmentRef([])
                setticketPriorityRef(null)
                setstudentIdRef("")
                setticketBranchRef(null)

                setdeadlineRef(null)

                setShowAddNewTicket(false)
                setEditorContent(null)
                setLogDescEditorContent(null)

                setShowToast(true)
                setToastType("success")
                setToastTitle("Success")
                setToastMessage("Ticket Created Successfully!")

            } else {
                console.log(createNewTicket.data)
                setShowToast(true)
                setToastType("error")
                setToastTitle("Error")
                setToastMessage(createNewTicket.data)
            }

        } else {
            const query = {
                "uid": masterTiccketUID,
                "ticketCategory": ticketCategoryRef,
                "ticketNumber": lastTicket,
                "status": ticketStatusRef,
                "subject": ticketSubjectRef,
                "department": ticketDepartmentRef,
                "subDepartment": ticketSubDepartmentRef,
                "createdBy": { "name": user.name, "email": user.email, "uid": user.uid },
                "raisedTo": ticketUserRef,
                "description": editorContent,
                "attachments": null,
                "priority": ticketPriorityRef,
                "studentId": studentIdRef,
                "assignedBranch": ticketBranchRef,
                "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY"),
                "overdue": {},
                "assignedStatus": {},
                "assignedTo": {},
                "escalationTo": {},
                "tags": finalTagsFormat,
                "logs": [{
                    "updatedByName": user.name,
                    "updatedByEmail": user.email,
                    "changed": `${user.name} created a new ticket`,
                    "updatedOn": dayjs().valueOf(),
                }]
            }
            // console.log(query)
            const createNewTicket = await axios.post(serverURL + "/tickets/create", query)
            if (createNewTicket.status === 200) {
                // console.log(createNewTicket.data)
                e.target.reset()

                // ############################### Send Notifications To Tagged Person ############################################### 

                console.log(finalTagsFormat)

                const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

                if (sendTaggedEmailsToMentionedPeople.status === 200) {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                } else {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                }

                socket.emit("ticketRaised", { "admin": user.email, "mentions": finalTagsFormat })
                setTags(null)
                // ############################### End Notifications To Tagged Person ###############################################

                setAllTicket([createNewTicket.data, ...allTicket])
                setLastTicket(lastTicket)

                // setticketCategoryRef(null)
                setticketSubjectRef("")
                setticketDepartmentRef(null)
                setticketSubDepartmentRef(null)
                setticketUserRef(null)
                setdescriptionRef("")
                setattachmentRef([])
                setticketPriorityRef(null)
                setstudentIdRef("")
                setticketBranchRef(null)
                setdeadlineRef(null)

                setShowAddNewTicket(false)
                setEditorContent(null)
                setLogDescEditorContent(null)


                setShowToast(true)
                setToastType("success")
                setToastTitle("Success")
                setToastMessage("Ticket Created Successfully!")
            } else {
                console.log(createNewTicket.data)
                setShowToast(true)
                setToastType("error")
                setToastTitle("Error")
                setToastMessage(createNewTicket.data)
            }
        }
    }

    const getAllTickets = async () => {

        setLoadingNewEmails(true)
        const query = {
            "limit": entriesLimit,
            "skip": skipEntries,
            "globleSearch": globleSearchValues,
            "filters": { "status": statusFilter?.value.toLowerCase(), "priority": priorityFilter?.value, "raisedTo": assignedToFilter?.value, "assignedBranch": branchFilter?.value }
        }



        console.log(query)

        const getAllTickets = await axios.post(serverURL + "/tickets/getAll", query)
        if (getAllTickets.status === 200) {
            // console.log(getAllTickets.data.lastTicketNumber.ticketNumber)
            setTotalEntriesCount(getAllTickets.data.total)

            if (getAllTickets.data.tickets.length > 0) {
                if (getAllTickets.data.lastTicketNumber) {
                    setLastTicket(getAllTickets.data.lastTicketNumber + 1)
                } else {
                    setLastTicket(getAllTickets.data.lastTicketNumber + 1)
                }
                // console.log(getAllTickets.data[0].ticketNumber)
            }


            let myTicketsFiltered = getAllTickets.data.tickets.filter((ticket) => {
                if (user.userType === "admin") {
                    return true
                }

                if (user.permissions.some((data) => data.value === "View-Unassigned-Tickets")) {
                    console.log("i have permission")
                    if (ticket.raisedTo === "" || ticket.raisedTo === "Not Assigned") {
                        return true
                    }
                } else {
                    console.log("I dont have permission")
                }

                if (ticket.tags.filter((tag) => { return tag.includes(user.email) }).length > 0) {
                    return true
                }

                return ticket.raisedTo?.value === user.email || ticket.createdBy?.email === user.email || ticket.raisedTo.otherData["Reporting Manager's Email ID"] === user.email || ticket.createdBy.reportingManager === user.manager
            })



            setAllTicket(myTicketsFiltered)

            let option = []

            myTicketsFiltered.map((user, key) => {
                return option.push({ "label": user.name, "value": user.uid })
            })

            setTicketOptions(option)

            setLoadingNewEmails(false)
        } else {
            console.log(getAllTickets.data)
            setAllTicket([])
            setLoadingNewEmails(false)
            // setShowToast(true)
            // setToastType("error")
            // setToastTitle("Error")
            // setToastMessage(getAllTickets.data)
        }

    }

    const changeStatusNow = async (e) => {
        e.preventDefault()

        let subjectOfTitle = ""

        if (isDataChanged.status) {
            subjectOfTitle = `${user.name} changed status to ${ticketStatus.label}`
        } else if (isDataChanged.assignedment) {
            subjectOfTitle = `${user.name} transfered this ticket to ${assgnedTo.label}`
        } else if (isDataChanged.deadline) {
            subjectOfTitle = `${user.name} changed deadline to ${deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY")}`
        } else {
            subjectOfTitle = `${user.name} added new note.`
        }

        let finalTagsFormat = []

        if (tags) {
            let filteredMentions = tags.filter((person) => { return person.id !== String(user.email).toLowerCase() && person.id !== String(ticketUserRef.value).toLowerCase() })

            filteredMentions.map((person, key) => {
                if (finalTagsFormat.includes(JSON.stringify(person))) {
                    return
                } else {
                    return finalTagsFormat.push(JSON.stringify(person))
                }
            })
        }

        let attachments = []
        if (attachmentRef.length > 0) {
            console.log("attached")

            for (let counter = 0; counter < attachmentRef.length; counter++) {
                await convertToBase64(attachmentRef[counter]).then((result) => {
                    attachments.push({
                        "fileData": result,
                        "uid": uuidv4(),
                        "name": attachmentRef[counter].name,
                        "type": attachmentRef[counter].type,
                        "size": attachmentRef[counter].size
                    })
                }).catch((err) => {
                    console.log(err)
                })
            }




            console.log(attachments)

            const query = {
                "uid": logToUse.uid,
                "updates": {
                    "status": ticketStatus,
                    "raisedTo": assgnedTo,
                    "tags": finalTagsFormat,
                    "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY")
                },
                "logs": {
                    "uid": uuidv4(),
                    "updatedByName": user.name,
                    "updatedByEmail": user.email,
                    "changed": subjectOfTitle,
                    "attachments": attachments,
                    "description": logDescEditorContent,
                    "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY"),
                    "updatedOn": dayjs().valueOf(),
                }
            }


            console.log(query)

            const updateNow = await axios.post(serverURL + "/tickets/update", query)
            if (updateNow.status === 200) {
                console.log("Done")



                // ############################### Send Notifications To Tagged Person ############################################### 

                console.log(finalTagsFormat)

                const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

                if (sendTaggedEmailsToMentionedPeople.status === 200) {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                } else {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                }

                setTags(null)
                // ############################### End Notifications To Tagged Person ###############################################


                setStatusChanged(true)
                setTimeout(() => {
                    setStatusChanged(false)
                    setStatusChanger(false)
                }, 2000)
                getAllTickets()
                setIsDataChanged({ "status": false, "assignedment": false, "comments": false })

                setLogToUse(null)
                setLogDescEditorContent(null)

                setShowToast(true)
                setToastType("success")
                setToastTitle("Success")
                setToastMessage("Ticket Updated Successfully!")
            } else {
                console.log(updateNow.data)
                setShowToast(true)
                setToastType("error")
                setToastTitle("Error")
                setToastMessage(updateNow.data)
            }
        } else {

            const query = {
                "uid": logToUse.uid,
                "updates": {
                    "status": ticketStatus,
                    "raisedTo": assgnedTo,
                    "tags": finalTagsFormat,
                    "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY")
                },
                "logs": {
                    "uid": uuidv4(),
                    "updatedByName": user.name,
                    "updatedByEmail": user.email,
                    "changed": subjectOfTitle,
                    "attachments": attachments,
                    "deadline": deadlineRef ? deadlineRef : dayjs().format("DD MMM YYYY"),
                    "description": logDescEditorContent,
                    "updatedOn": dayjs().valueOf(),
                }
            }


            console.log(query)

            const updateNow = await axios.post(serverURL + "/tickets/update", query)
            if (updateNow.status === 200) {
                console.log("Done")



                // ############################### Send Notifications To Tagged Person ############################################### 

                console.log(finalTagsFormat)

                const sendTaggedEmailsToMentionedPeople = await axios.post(serverURL + "/tickets/sendMentionedEmails", { "members": finalTagsFormat, "ticketNumber": lastTicket, "admin": { "id": user.email, "name": user.name } })

                if (sendTaggedEmailsToMentionedPeople.status === 200) {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                } else {
                    console.log(sendTaggedEmailsToMentionedPeople.data)
                }

                setTags(null)
                // ############################### End Notifications To Tagged Person ###############################################


                setStatusChanged(true)
                setTimeout(() => {
                    setStatusChanged(false)
                    setStatusChanger(false)
                }, 2000)
                getAllTickets()
                setLogToUse(null)
                setLogDescEditorContent(null)
                setShowToast(true)
                setToastType("success")
                setToastTitle("Success")
                setToastMessage("Ticket Updated Successfully!")
                setIsDataChanged({ "status": false, "assignedment": false, "comments": false })
            } else {
                console.log(updateNow.data)

                setShowToast(true)
                setToastType("error")
                setToastTitle("Error")
                setToastMessage(updateNow.data)
            }
        }
    }


    const changeDepartment = (e, values) => {
        // console.log(values)
        if (values) {
            if (ticketDepartmentRef && ticketDepartmentRef.value === values.value) {
                setticketDepartmentRef(values)
            } else {
                setticketDepartmentRef(values)
                setticketSubDepartmentRef(null)
                setticketUserRef(null)
            }
        } else {
            setticketDepartmentRef(null)
            setticketSubDepartmentRef(null)
            setticketUserRef(null)
        }
    }

    const changeSubDepartments = (e, values) => {
        // console.log(values)
        if (values) {
            if (ticketSubDepartmentRef && ticketSubDepartmentRef.value === values.value) {
                setticketSubDepartmentRef(values)
            } else {
                setticketUserRef(null)
                setticketSubDepartmentRef(values)
            }
        } else {
            setticketSubDepartmentRef(null)
        }
    }

    const changeBranch = (e, values) => {
        setticketBranchRef(values)
    }

    const changePriority = (e, values) => {
        setticketPriorityRef(values)
    }

    const changeUser = (e, values) => {
        // console.log(values)
        if (values) {
            if (ticketDepartmentRef) {
                setticketDepartmentRef(null)
                setticketDepartmentRef(departmentOptions.filter((dep) => {
                    // console.log(dep.value + "===" + values.department)
                    return dep.value === values.department
                })[0])
                setticketUserRef(values)
            } else {
                setticketDepartmentRef(null)
                setticketDepartmentRef(departmentOptions.filter((dep) => {
                    console.log(dep.value + "===" + values.department)
                    return dep.value === values.department
                })[0])
                setticketUserRef(values)
            }
        }
        else {
            setticketUserRef(null)
        }
    }

    const showAttachmentPreviewNow = async (refId, docId) => {
        setShowAttachmentPreview(true);

        const getAttachedFile = await axios.post(serverURL + "/attachments/get", { "refId": refId, "docId": docId })

        if (getAttachedFile.status === 200) {
            // console.log(getAttachedFile.data)
            setAttachmentToUse(getAttachedFile.data);
        } else {
            console.log(getAttachedFile.data)
        }


    }

    const getAllEmailsFromAccounts = async () => {

        const getEmailAccountsNow = await axios.post(serverURL + "/emailAccounts/getEmailAccounts")
        if (getEmailAccountsNow.status === 200) {
            const accounts = getEmailAccountsNow.data

            // console.log({ "email accounts": accounts })

            const emailArrays = []

            accounts.map((accnt, key) => {
                if (accnt.status) {
                    return emailArrays.push({ "email": accnt.email, "pageToken": currentPageToken })
                }
            })

            if (emailArrays.length > 0) {

                // console.log(emailArrays[0])

                const getAllEmails = await axios.post(serverURL + "/emailAccounts/getEmailsFromAccount", { "account": emailArrays[0] })
                if (getAllEmails.status === 200) {
                    // console.log(getAllEmails.data)
                    setAllTicketsFromEmail(getAllEmails.data.allEmails)
                    setCurrentPageToken({ "email": emailArrays[0].email, "token": getAllEmails.data.nextPageToken })
                } else {
                    // console.log(getAllEmails.data)
                    setShowToast(true)
                    setToastType("error")
                    setToastTitle("Error")
                    setToastMessage(getAllEmails.data)
                }
            }
        } else {
            setShowToast(true)
            setToastType("error")
            setToastTitle("Error")
            setToastMessage(getEmailAccountsNow.data)
        }
    }


    const updateSyncedFromEmailAccountMessages = async (messageData, newNumber, automationRules) => {

        let finalStatus = { "label": "open", "value": "open" }
        let finalPriority = { "label": "Low", "value": "Low" }
        let finalAssignment = { "value": "Not Assigned", "label": "Not Assigned", "otherData": { "Reporting Manager's Email ID": "Not Assigned" } }


        let fromEmailToUse = ""
        if (messageData.from.includes("<")) {
            fromEmailToUse = messageData.from.split("<")[1].split(">")[0].replaceAll('"', '').replaceAll("'", "")
        }


        const findStudentInStudentMaster = await axios.post(serverURL + "/studentMaster/searchStudentByEmail", { email: fromEmailToUse })




        if (automationRules.length > 0 && findStudentInStudentMaster.status === 200) {
            // console.log(findStudentInStudentMaster.data.LocCode, fromEmailToUse)
            let changed = false
            for (let rule of automationRules) {

                if (rule.conditionLogic === "AND") {
                    let result = rule.conditions.every((condition) => {
                        if (condition.type === "tickets") {
                            if (condition.rule === "created-by") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }

                            } else if (condition.rule === "raised-to") {
                                // concerns regarding that
                            } else if (condition.rule === "subject") {
                                if (condition.logic === "contains") {
                                    if (messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.subject === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else {
                                return false
                            }
                        } else if (condition.type === "students") {
                            if (condition.rule === "intake") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.intakecode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else if (condition.rule === "branch") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.LocCode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "student-email-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "student-yg-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else {
                                return false
                            }
                        } else if (condition.type === "yg-mail") {
                            if (condition.rule === "intake") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.intakecode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else if (condition.rule === "branch") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.LocCode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else if (condition.rule === "student-yg-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "subject") {
                                if (condition.logic === "contains") {
                                    if (messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.subject === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else {
                                return false
                            }
                        } else {
                            return false
                        }
                    })

                    if (result) {
                        changed = true
                    }
                } else {
                    let result = rule.conditions.some((condition) => {
                        if (condition.type === "tickets") {
                            if (condition.rule === "created-by") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }

                            } else if (condition.rule === "raised-by") {
                                // concerns regarding that
                            } else if (condition.rule === "subject") {
                                if (condition.logic === "contains") {
                                    if (messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.subject === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else {
                                return false
                            }
                        } else if (condition.type === "students") {
                            if (condition.rule === "intake") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.intakecode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.intakecode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.intakecode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            } else if (condition.rule === "branch") {
                                if (condition.logic === "contains") {
                                    if (findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!findStudentInStudentMaster.data.LocCode?.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (findStudentInStudentMaster.data.LocCode === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return findStudentInStudentMaster.data.LocCode?.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "student-email-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "student-yg-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else {
                                return false
                            }
                        } else if (condition.type === "yg-mail") {
                            if (condition.rule === "intake") {

                            } else if (condition.rule === "branch") {

                            } else if (condition.rule === "student-yg-id") {
                                if (condition.logic === "contains") {
                                    if (messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.from.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.from === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.from.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else if (condition.rule === "subject") {
                                if (condition.logic === "contains") {
                                    if (messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-contains") {
                                    if (!messageData.subject.includes(condition.value)) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "exact-match") {
                                    if (messageData.subject === condition.value) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else if (condition.logic === "not-in") {
                                    if (!condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }

                                }
                                else if (condition.logic === "in") {
                                    if (condition.value.split(",").some((val) => { return messageData.subject.includes(val) })) {
                                        return true
                                    } else {
                                        return false
                                    }
                                }
                                else {
                                    return false
                                }
                            }
                            else {
                                return false
                            }
                        } else {
                            return false
                        }
                    })

                    if (result) {
                        changed = true
                    }
                }

            }

            if (changed) {

                for (let rule of automationRules) {
                    rule.actions.map((action, key) => {
                        Object.keys(action).map((keyName, key) => {

                            // console.log(action[keyName])

                            if (keyName === "ticket-status") {
                                finalStatus = { "label": action[keyName], "value": action[keyName] }
                            }
                            else if (keyName === "ticket-assigned-to") {
                                finalAssignment = { "value": action[keyName], "label": action[keyName], "otherData": { "Reporting Manager's Email ID": "Not Assigned" } }
                            }
                            else if (keyName === "ticket-priority-as") {
                                finalPriority = { "label": action[keyName], "value": action[keyName] }
                            }
                            else { }
                        })
                    })
                }

            }
        }


        let finalDepartment = ""
        let finalSubDepartment = ""
        let reportingManager = ""



        let finalEmailFormatToUse = ""
        if (finalAssignment.value.includes("<")) {
            finalEmailFormatToUse = finalAssignment.value.split("<")[1].split(">")[0].replaceAll('"', '').replaceAll("'", "")
        } else {
            finalEmailFormatToUse = finalAssignment.value
        }

        const searchPersonInFormDataByEmail = await axios.post(serverURL + "/forms/searchPersonInFormDataByEmail", { "email": finalEmailFormatToUse })




        if (searchPersonInFormDataByEmail.status === 200) {
            // console.log(finalEmailFormatToUse)

            finalDepartment = searchPersonInFormDataByEmail.data.submittedData["Process / Department"]
            finalSubDepartment = searchPersonInFormDataByEmail.data.submittedData["Sub Department"]
            reportingManager = searchPersonInFormDataByEmail.data.submittedData["Reporting Manager's Email ID"]
        }




        let updatedfinalAssignment = { "value": finalEmailFormatToUse, "label": finalEmailFormatToUse, "otherData": { "Reporting Manager's Email ID": reportingManager } }



        let attachments = []

        if (messageData.attachments.length > 0) {
            // console.log("attached")
            for (let counter = 0; counter < messageData.attachments.length; counter++) {
                attachments.push({
                    "fileData": `data:${messageData.attachments[counter].mimeType};base64,${messageData.attachments[counter].data.replace(/_/g, '/').replace(/-/g, '+')}`,
                    "uid": uuidv4(),
                    "name": messageData.attachments[counter].filename,
                    "type": messageData.attachments[counter].mimeType,
                    "size": messageData.attachments[counter].size
                })
            }
        }





        const query = {
            "uid": messageData.id,
            "ticketCategory": { "label": "Students", "value": "students" },
            "ticketNumber": newNumber,
            "status": finalStatus,
            "subject": messageData.subject,
            "department": { "value": finalDepartment, "label": finalDepartment },
            "subDepartment": { "value": finalSubDepartment, "label": finalSubDepartment },
            "createdBy": { "name": messageData.from?.split("<")[0]?.replaceAll('"', ''), "email": messageData.from, "uid": user.uid },
            "raisedTo": updatedfinalAssignment,
            "description": messageData.body,
            "attachments": attachments.length > 0 ? attachments : null,
            "priority": finalPriority,
            "studentId": findStudentInStudentMaster.data.Stdid,
            "assignedBranch": ticketBranchRef,
            "deadline": new Date(),
            "overdue": {},
            "assignedStatus": {},
            "assignedTo": {},
            "escalationTo": {},
            "logs": [{
                "updatedByName": messageData.from?.split("<")[0],
                "updatedByEmail": messageData.from,
                "changed": `${messageData.from?.split("<")[0]} created a new ticket`,
                "updatedOn": dayjs().valueOf(),
            }]
        }
        // console.log(query)
        const createNewTicket = await axios.post(serverURL + "/tickets/createAutoGen", query)
        if (createNewTicket.status === 200) {
            // console.log(createNewTicket.data)
            // socket.emit("ticketRaised")
            // setAllTicket([createNewTicket.data, ...allTicket])
            setLastTicket(newNumber)


            setShowToast(true)
            setToastType("success")
            setToastTitle("Success")
            setToastMessage("Ticket Created Successfully!")
        } else {
            // console.log(createNewTicket.data)
            setShowToast(true)
            setToastType("error")
            setToastTitle("Error")
            setToastMessage(createNewTicket.data)
        }
    }

    useEffect(() => {
        getAllTickets()
    }, [skipEntries, entriesLimit])

    useEffect(() => {
        if (allTicketsFromEmail?.length > 0 && allAutomationRulesReady) {
            allTicketsFromEmail.map((message, key) => {
                // console.log(key)
                setTimeout(async () => {
                    let newNumber = lastTicket + (key + 1)
                    if (allAutomationRules) {
                        updateSyncedFromEmailAccountMessages(message, newNumber, allAutomationRules)
                    } else {
                        updateSyncedFromEmailAccountMessages(message, newNumber, null)
                    }
                }, 1000)
            })
        }
    }, [allTicketsFromEmail, allAutomationRulesReady])

    const nextPageEmails = async (email, pageToken) => {

        setLoadingNewEmails(true)

        const emailAccount = { "email": email, "pageToken": pageToken }
        const getAllEmails = await axios.post(serverURL + "/emailAccounts/getEmailsFromAccount", { "account": emailAccount })
        if (getAllEmails.status === 200) {
            console.log(getAllEmails.data)
            setLoadingNewEmails(false)
            setCurrentPageToken({ "email": email, "token": getAllEmails.data.nextPageToken })
            setAllTicketsFromEmail(getAllEmails.data.allEmails)
        } else {
            console.log(getAllEmails.data)
            setLoadingNewEmails(false)
            setShowToast(true)
            setToastType("error")
            setToastTitle("Error")
            setToastMessage(getAllEmails.data)
        }
    }

    useEffect(() => {
        if (userOptions.length > 0) {
            getAllTickets()
        }
    }, [statusFilter, priorityFilter, assignedToFilter, branchFilter, globleSearchValues])


    useEffect(() => {
        if (userOptions.length > 0) {
            // if (userData.submittedData["Official Mail Id"].toLowerCase() === user.email.toLowerCase()) {
            //     console.log("same")
            //     setAssignedToFilter({ "label": userData.submittedData["Employee Name"], "value": userData.submittedData["Official Mail Id"] })
            // }

            console.log(userOptions.find((usrdata) => { return usrdata.value === user.email }))

            setAssignedToFilter(userOptions.find((usrdata) => { return usrdata.value === user.email }))
        }
    }, [userOptions])


    useEffect(() => {
        if (!logToUse) {
            setLogDescEditorContent(null)
            setIsDataChanged({ "status": false, "assignedment": false, "comments": false })
            setEditorContent(null)
            setShowAddNewTicket(false)
        }
    }, [logToUse])



    const getAllAutomationRules = async () => {
        let automationRules = await axios.post(serverURL + "/tar/getAllRules")
        if (automationRules.status === 200) {
            setAllAutomationRules(automationRules.data)
            setAllAutomationRulesReady(true)
        } else {
            setAllAutomationRulesReady(true)
        }
    }

    useEffect(() => {
        getAllDepartments()
        getAllTickets()
        // getAllTicketsFromEmail()
        getAllEmailsFromAccounts()
        socket.on("ticketArrived", () => {
            getAllTickets()
        })

        getAllAutomationRules()
    }, [])

    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Tickets</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='d-flex gap-2 justify-content-between align-items-streach px-3 py-1 shadow-sm w-100'>
                    <div className='w-100 d-flex  align-items-center'>
                        <Breadcrumbs aria-label="breadcrumb">
                            <StyledBreadcrumb
                                component="span"
                                label="All Tickets"
                                onClick={() => { setLogToUse(null); setShowAddNewTicket(false); setEditorContent(null) }}
                                icon={<HomeIcon fontSize="small" />}
                            />

                            {
                                logToUse &&
                                <StyledBreadcrumb component="span" label={`YG${logToUse?.ticketNumber?.toString().padStart(8, '0')}`} />
                            }
                            {/* <StyledBreadcrumb
                                label="Accessories"
                                deleteIcon={<ExpandMoreIcon />}
                                onDelete={handleClick}
                            /> */}
                        </Breadcrumbs>
                    </div>
                    <div className='d-flex align-items-center gap-3'>
                        {/* {
                            currentPageToken &&
                            <button disabled={loadingNewEmails} className='btn btn-sm rounded-pill btn-success text-nowrap' onClick={() => { nextPageEmails(currentPageToken.email, currentPageToken.token) }}>
                                {
                                    loadingNewEmails ?
                                        <div className='d-flex align-items-center gap-1'>
                                            <CustomSpinner size={1} />
                                            <span>
                                                Loading
                                            </span>
                                        </div>
                                        :
                                        "Next Page"
                                }

                            </button>
                        } */}
                        <AnimatePresence>
                            {
                                !logToUse &&
                                <motion.button
                                    initial={{ scale: 0, rotateZ: 90 }}
                                    animate={{ scale: 1, rotateZ: 0 }}
                                    exit={{ scale: 0, rotateZ: 90 }}
                                    transition={{ duration: .5, delay: 0 }}
                                    title='Add Ticket' className={`btn btn-sm rounded-pill ${showAddNewTicket ? "btn-outline-danger" : "btn-outline-secondary"} d-flex align-items-center p-1`} style={{ aspectRatio: "1/1" }} onClick={() => { setShowAddNewTicket(!showAddNewTicket); }}>
                                    <AddIcon style={showAddNewTicket ? { aspectRatio: "1/1", transform: "rotateZ(45deg)", transition: ".3s ease-in-out" } : { aspectRatio: "1/1", transform: "rotateZ(0deg)", transition: ".3s ease-in-out" }} />
                                </motion.button>
                            }
                        </AnimatePresence>
                        <div className='d-flex shadow-sm rounded-pill border px-1'>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="Global Search"
                                inputProps={{ 'aria-label': 'Global Search' }}
                                onChange={(e) => { console.log(e.target.value); setGlobleSearchValues(e.target.value) }}
                            />
                            <IconButton type="button" sx={{ p: '5px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                        </div>
                    </div>
                </div>

                <div className={`w-100 h-100 overflow-auto d-flex gap-2 p-3`}>
                    <div className={`w-100 h-100 overflow-auto d-flex flex-column justify-content-start align-items-start gap-3`}>
                        {
                            logToUse ?
                                <form onSubmit={(e) => { changeStatusNow(e) }} action="" className='w-100 h-100 d-flex gap-1'>
                                    <div className='w-100 h-100 p-3 shadow-sm border rounded-4 overflow-auto cardsTransparent '>
                                        <div className='d-flex flex-column gap-2 h-100 w-100 overflow-auto' >

                                            <div className='d-flex flex-column gap-1 overflow-auto'>
                                                {
                                                    logToUse?.logs.sort((a, b) => b.updatedOn - a.updatedOn).map((log, key) => {
                                                        return (
                                                            <div key={key} className={`alert alert-light shadow-sm rounded-3 px-2 py-2 w-100`}>
                                                                <div className='d-flex justify-content-between w-100'>
                                                                    <div className='d-flex align-items-center gap-1'>
                                                                        <img src={`https://placehold.co/40x40/000000/fff?text=${log.updatedByName?.split(" ").map((word, key) => { return word[0] }).join("")}`} alt="" style={{ height: "30px" }} className='rounded-circle border' />
                                                                        <span className='text-dark fs-6 fw-bold'>{log.changed}</span>
                                                                    </div>
                                                                    <span className='text-muted'>{dayjs(log.updatedOn).format("DD MMMM YYYY h:mma")}</span>
                                                                </div>
                                                                <div className='d-flex flex-column'>
                                                                    <RTE
                                                                        addYoutubeVideoShow={addYoutubeVideoShow}
                                                                        setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                                                                        urlRef={urlRef}
                                                                        videoAdded={videoAdded}
                                                                        editorContent={log.description}
                                                                        setEditorContent={setEditorContent}
                                                                        isEditable={false}
                                                                        setattachmentRef={setattachmentRef}
                                                                        isDataChanged={isDataChanged}
                                                                        setIsDataChanged={setIsDataChanged}
                                                                        setTags={setTags}
                                                                    />
                                                                    <div className='d-flex flex-wrap align-items-center gap-1'>
                                                                        {
                                                                            log.attachments?.files?.length > 0 ?
                                                                                log.attachments?.files.map((file, key) => {
                                                                                    return (
                                                                                        <span className="d-flex gap-1 align-items-center px-1 pt-2" style={{ cursor: "pointer" }} onClick={() => { showAttachmentPreviewNow(log.attachments.refId, file.uid); }}>
                                                                                            {
                                                                                                file.type?.includes("video") ?
                                                                                                    <MovieIcon />
                                                                                                    :
                                                                                                    file?.type?.includes("image") ?
                                                                                                        <PermMediaIcon />
                                                                                                        :
                                                                                                        file?.type?.includes("audio") ?
                                                                                                            <AudiotrackIcon />
                                                                                                            :
                                                                                                            file?.type?.includes("audio") ?
                                                                                                                <AudioFileIcon />
                                                                                                                :
                                                                                                                file?.type?.includes("video") ?
                                                                                                                    <VideoFileIcon />
                                                                                                                    :
                                                                                                                    file?.type?.includes("pdf") ?
                                                                                                                        <PictureAsPdfIcon />
                                                                                                                        :
                                                                                                                        ""
                                                                                            }
                                                                                            <p className='text-truncate w-100 m-0' title={file.name}>{file.name}</p>
                                                                                        </span>
                                                                                    )
                                                                                })
                                                                                :
                                                                                ""
                                                                        }
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {
                                                logToUse.status?.label !== 'Closed' &&
                                                <div className='bg-light d-flex flex-column p-3 rounded-4'>
                                                    {/* <label htmlFor='uthaLeImage1' className='m-0'>
                                                            <img src={AttachmentIcon} alt="" style={{ height: "30px" }} />
                                                        </label>
                                                        <input type="file" id="uthaLeImage1" className='form-control w-100 d-none' onInput={(e) => { setattachmentRef(e.target.files[0]) }} /> */}
                                                    {/* <TextField className='w-100' label="Description" required variant="outlined" onChange={(e) => { setdescriptionRef(e.target.value) }} /> */}

                                                    <RTE
                                                        addYoutubeVideoShow={addYoutubeVideoShow}
                                                        setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                                                        urlRef={urlRef}
                                                        videoAdded={videoAdded}
                                                        editorContent={logDescEditorContent}
                                                        setEditorContent={setLogDescEditorContent}
                                                        isEditable={true}
                                                        setattachmentRef={setattachmentRef}
                                                        isDataChanged={isDataChanged}
                                                        setIsDataChanged={setIsDataChanged}
                                                        setTags={setTags}
                                                    />
                                                </div>
                                            }

                                            {
                                                statusChanged ?
                                                    <div className='alert alert-success p-1 m-0 w-100 text-center'>
                                                        Updated Successfully!
                                                    </div>
                                                    :
                                                    ""
                                            }
                                        </div>
                                    </div>
                                    <div className='w-100 h-100 p-2 shadow-sm border rounded-4 overflow-auto d-flex flex-column cardsTransparent' style={{ maxWidth: "300px" }}>
                                        <div className='p-2 border-bottom mb-2 fw-bod'>
                                            <span style={{ fontWeight: "500" }}>{`#YG${logToUse?.ticketNumber?.toString().padStart(8, '0')}`}</span>
                                            <p className='text-truncate m-0' title={logToUse?.subject}>
                                                {logToUse?.subject}
                                            </p>
                                        </div>
                                        <div className='w-100 h-100 overflow-auto p-2 d-flex flex-column justify-content-between'>
                                            <div className='d-flex flex-column gap-3'>
                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    disabled
                                                    value={logToUse.createdBy?.email}
                                                    options={null}
                                                    sx={{ width: "100%" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField {...params} required label="Created By" />}
                                                />

                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    disabled
                                                    value={logToUse.department?.label}
                                                    options={null}
                                                    sx={{ width: "100%" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField {...params} required label="Department" />}
                                                />
                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    disabled
                                                    value={dayjs(logToUse.createdAt).format("DD MMMM YYYY h:mma")}
                                                    options={null}
                                                    sx={{ width: "100%" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField {...params} required label="Created At" />}
                                                />

                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    value={ticketStatus}
                                                    onChange={(event, newValues) => {
                                                        if (logToUse.status.label === newValues.label) {
                                                            console.log("Status is default")
                                                            setIsDataChanged({ "comments": isDataChanged.comments, "assignedment": isDataChanged.assignedment, "status": false, "deadline": isDataChanged.deadline })
                                                        } else {
                                                            console.log("Status is changed")
                                                            setIsDataChanged({ "comments": isDataChanged.comments, "assignedment": isDataChanged.assignedment, "status": true, "deadline": isDataChanged.deadline })
                                                        }
                                                        setTicketStatus(newValues)
                                                    }}
                                                    disabled={!logToUse.createdBy?.email.includes(user.email) && !logToUse.raisedTo?.value?.includes(user.email)}
                                                    options={ticketStatusOptions}
                                                    sx={{ width: "100%" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField {...params} required label="Status" />}
                                                />

                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    disabled={!user.permissions.some((data) => data.value === "Unassigned-Ticket-Assignment") ? true : false || ticketStatus.label === "Closed" ? true : false || logToUse.tags.filter((tag) => { return tag.includes(user.email) }).length > 0}
                                                    value={assgnedTo}
                                                    defaultValue={logToUse.raisedTo}
                                                    onChange={(event, newValues) => {
                                                        if (logToUse.raisedTo?.label === newValues?.label) {
                                                            console.log("Assignment is default")
                                                            setIsDataChanged({ "comments": isDataChanged.comments, "assignedment": false, "status": isDataChanged.status, "deadline": isDataChanged.deadline })
                                                        } else {
                                                            console.log("Assignment is changed")
                                                            setIsDataChanged({ "comments": isDataChanged.comments, "assignedment": true, "status": isDataChanged.status, "deadline": isDataChanged.deadline })
                                                        }
                                                        setAssgnedTo(newValues)
                                                    }}
                                                    options={[
                                                        // logToUse.raisedTo.otherData["Reporting Manager's Email ID"] === user.email ? [] : logToUse.raisedTo,
                                                        ...assignedToOptions.filter((oneOfAllEmployee) => {
                                                            if ((
                                                                oneOfAllEmployee.otherData["Reporting Manager's Email ID"] === logToUse.raisedTo?.value && logToUse.createdBy?.email !== user.email) ||
                                                                oneOfAllEmployee.otherData["Reporting Manager's Email ID"] === user.email) {
                                                                return true
                                                            }
                                                            else if (oneOfAllEmployee.value === user.email) {
                                                                return true
                                                            }
                                                            else {
                                                                return false
                                                            }
                                                        })]}
                                                    sx={{ width: "100%" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField {...params} required label="Assigned To" />}
                                                />

                                                <div sx={{ width: "100%" }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker label="Deadline / Followup" format='DD MMM YYYY'
                                                            sx={{ width: "100%" }}
                                                            minDate={dayjs()}
                                                            required
                                                            disabled={logToUse.status.value === "closed" || user.email !== logToUse.createdBy.email}
                                                            value={dayjs(logToUse?.deadline)}
                                                            onChange={(e) => { setdeadlineRef(e); setIsDataChanged({ "comments": isDataChanged.comments, "assignedment": isDataChanged.assignedment, "status": isDataChanged.status, "deadline": true }) }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                            <button type='submit' className='btn btn-md btn-dark w-100 rounded-2' disabled={(isDataChanged.status || isDataChanged.assignedment || isDataChanged.comments || isDataChanged.deadline) ? false : true}>Update</button>
                                        </div>
                                    </div>
                                </form>
                                :
                                showAddNewTicket && !logToUse ?
                                    <div className='rounded-3 shadow-sm border d-flex flex-column w-100 cardsTransparent'>
                                        <p className='w-100 fs-5 text-center m-0 py-3 sticky-top'>New Ticket</p>
                                        <form action="" onSubmit={(e) => { createTicketNow(e) }} className={`d-flex flex-column gap-3 px-3 py-4 bg-light  rounded-4 shadow-sm border`} ref={dakiyaRef}>
                                            <div className='d-flex flex-wrap gap-3 justify-content-around align-items-start'>
                                                {/* <Autocomplete
                                                    disablePortal
                                                    required
                                                    value={ticketCategoryRef}
                                                    onChange={(event, newValues) => changeCategory(event, newValues)}
                                                    options={[
                                                        { "label": "General", "value": "general" },
                                                        { "label": "Student Process", "value": "student-process" },
                                                    ]}
                                                    sx={{ width: "100%", maxWidth: "300px" }}
                                                    renderInput={(params) => <TextField {...params} label="Ticket Category" />}
                                                /> */}
                                                <TextField
                                                    id="outlined-basic"
                                                    required
                                                    className='w-100'
                                                    style={{ maxWidth: "250px" }}
                                                    label="Ticket Subject"
                                                    variant="outlined"
                                                    onInput={(e) => { setticketSubjectRef(e.target.value) }} />


                                                {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                    <InputLabel htmlFor="grouped-select">Grouping</InputLabel>
                                                    <Select defaultValue="" id="grouped-select" label="Grouping">
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <ListSubheader>Category 1</ListSubheader>
                                                        <MenuItem value={1}>Option 1</MenuItem>
                                                        <MenuItem value={2}>Option 2</MenuItem>
                                                        <ListSubheader>Category 2</ListSubheader>
                                                        <MenuItem value={3}>Option 3</MenuItem>
                                                        <MenuItem value={4}>Option 4</MenuItem>
                                                    </Select>
                                                </FormControl> */}
                                                {/* <Select  defaultValue="" id="grouped-native-select" label="Grouping">
                                                    <option aria-label="None" value="" />
                                                    <optgroup label="Category 1">
                                                        <option value={1}>Option 1</option>
                                                        <option value={2}>Option 2</option>
                                                    </optgroup>
                                                    <optgroup label="Category 2">
                                                        <option value={3}>Option 3</option>
                                                        <option value={4}>Option 4</option>
                                                    </optgroup>
                                                </Select> */}

                                                <Autocomplete
                                                    disablePortal
                                                    value={ticketDepartmentRef}
                                                    onChange={(event, newValues) => changeDepartment(event, newValues)}
                                                    options={departmentOptions}
                                                    sx={{ width: "100%", maxWidth: "250px" }}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField required {...params} label="Department" />}
                                                />
                                                <Autocomplete
                                                    disablePortal
                                                    value={ticketSubDepartmentRef}
                                                    onChange={(event, newValues) => changeSubDepartments(event, newValues)}
                                                    options={ticketDepartmentRef ? subDepartmentOptions.filter((subDep) => { return subDep.department === ticketDepartmentRef?.label }) : []}
                                                    sx={{ width: "100%", maxWidth: "250px" }}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField required {...params} label="Sub Department" />}
                                                />

                                                <Autocomplete
                                                    disablePortal
                                                    required
                                                    value={ticketPriorityRef}
                                                    onChange={(event, newValues) => changePriority(event, newValues)}
                                                    options={[
                                                        { "label": "High", "value": "High" },
                                                        { "label": "Medium", "value": "Medium" },
                                                        { "label": "Low", "value": "Low" }
                                                    ]}
                                                    sx={{ width: "100%", maxWidth: "250px" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField required {...params} label="Priority" />}
                                                />
                                                <Autocomplete
                                                    disablePortal
                                                    value={ticketUserRef}
                                                    onChange={(event, newValues) => changeUser(event, newValues)}
                                                    options={ticketDepartmentRef && ticketSubDepartmentRef ? userOptions.filter((userDet) => { return (userDet.department === ticketDepartmentRef?.label) && (userDet.subDepartment === ticketSubDepartmentRef?.label) }) : [{ label: "Not Assigned", value: "Not Assigned" }]}
                                                    sx={{ width: "100%", maxWidth: "250px" }}
                                                    multiple={false}
                                                    getOptionLabel={(option) => {
                                                        if (!option) return '';
                                                        if (typeof option === 'string') return option;
                                                        if (typeof option.label === 'string') return option.label;
                                                        return '';
                                                    }}
                                                    renderInput={(params) => <TextField required {...params} label="Select User" />}
                                                />

                                                <div sx={{ width: "100%", maxWidth: "250px" }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker label="Deadline / Followup" minDate={dayjs()} required value={deadlineRef} onChange={(e) => { setdeadlineRef(e); }} />
                                                    </LocalizationProvider>
                                                </div>

                                                {/* <TextField className='w-100' required type="date" label="Deadline" style={{ maxWidth: "300px" }} defaultValue={dayjs().add(1, "day").format("YYYY-MM-DD")} variant="outlined" value={deadlineRef} onInput={(e) => { setdeadlineRef(e.target.value) }} /> */}
                                                {/* <label htmlFor='uthaLeImage2' className='m-0'>
                                                    <img src={AttachmentIcon} alt="" style={{ height: "30px" }} />
                                                </label>
                                                <input type="file" id="uthaLeImage2" className='form-control w-100 d-none' onInput={(e) => { setattachmentRef(e.target.files[0]) }} /> */}
                                            </div>

                                            {/* <TextField className='w-100' label="Description" variant="outlined" value={descriptionRef} onInput={(e) => { setdescriptionRef(e.target.value) }} /> */}

                                            <div className='d-flex flex-column gap-4'>
                                                <RTE
                                                    addYoutubeVideoShow={addYoutubeVideoShow}
                                                    setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                                                    urlRef={urlRef}
                                                    videoAdded={videoAdded}
                                                    editorContent={editorContent}
                                                    setEditorContent={setEditorContent}
                                                    isEditable={true}
                                                    setattachmentRef={setattachmentRef}
                                                    isDataChanged={isDataChanged}
                                                    setIsDataChanged={setIsDataChanged}
                                                    setTags={setTags}
                                                />
                                                {
                                                    ticketCreated ?
                                                        <div className='alert alert-success p-1 m-0 w-100 text-center'>
                                                            Ticket Created
                                                        </div>
                                                        :
                                                        ""
                                                }
                                                <div className='d-flex w-100 justify-content-center'>
                                                    <button type='submit' className='btn btn-md btn-primary w-100 rounded-3 shadow' style={{ maxWidth: "120px" }}>Create</button>
                                                </div>
                                            </div>

                                        </form>
                                        <div className="alert alert-info mt-1 rounded-4">
                                            <b>Note:</b> If user not found, Please connect with HR Department!
                                        </div>
                                    </div>
                                    :
                                    <div className='d-flex flex-column h-100 w-100 overflow-hidden cardsTransparent rounded-4'>
                                        <div className='w-100 h-100 d-flex flex-column rounded-0 shadow-sm overflow-auto cardsTransparent p-0'>

                                            {
                                                loadingNewEmails ?
                                                    <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                                                        <CustomSpinner size={1} />
                                                    </div>
                                                    :
                                                    <table className='table table-yesgermany m-0 table-hover'>
                                                        <thead className='sticky-top'>
                                                            <tr align="center">
                                                                <th className='text-nowrap'>#{totalEntriesCount}</th>
                                                                <th className='text-nowrap'>Follow Up</th>
                                                                <th className='text-nowrap'>Last Modified</th>
                                                                <th className='text-nowrap'>Priority</th>
                                                                <th className='text-nowrap'>Ticket Status</th>
                                                                <th className='text-wrap' style={{ maxWidth: "300px" }}>Subject</th>
                                                                <th className='text-nowrap'>Sub Department</th>
                                                                <th className='text-nowrap'>Assigned To</th>
                                                                <th className='text-nowrap'>Created By</th>
                                                                {/* <th className='text-nowrap'>Ticket ID</th> */}
                                                                {/* <th className='text-nowrap'>Department</th> */}
                                                                {/* <th className='text-nowrap'>Description</th> */}
                                                                {/* <th className='text-nowrap'>Student ID</th>
                                                                <th className='text-nowrap'>Branch</th>
                                                                <th className='text-nowrap'>Deadline</th>
                                                                <th className='text-nowrap'>Overdue</th>
                                                                <th className='text-nowrap'>Assigned Status</th>
                                                                <th className='text-nowrap'>Assigned To</th>
                                                                <th className='text-nowrap'>Escalation To</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                allTicket.length > 0 ?
                                                                    allTicket.map((ticket, key) => {
                                                                        return (
                                                                            <tr align="center" key={key}
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    setLogToUse(ticket);
                                                                                    setAssgnedTo(ticket.raisedTo);
                                                                                    setShowLogs(true);
                                                                                    setEditorContent(ticket.description);
                                                                                    setTicketStatus(ticket.status);
                                                                                    setTicketStatusOptions(
                                                                                        ticket.status.label === "Open" ?
                                                                                            [
                                                                                                { "label": "Open", "value": "open" },
                                                                                                { "label": "In-Process", "value": "in-process" },
                                                                                                { "label": "Closed", "value": "closed" },
                                                                                            ]
                                                                                            :
                                                                                            ticket.status.label === "In-Process" ?
                                                                                                [
                                                                                                    { "label": "In-Process", "value": "in-process" },
                                                                                                    { "label": "Closed", "value": "closed" },
                                                                                                ]
                                                                                                :
                                                                                                ticket.status.label === "Re-Open" ?
                                                                                                    [
                                                                                                        { "label": "Re-Open", "value": "re-open" },
                                                                                                        { "label": "Closed", "value": "closed" },
                                                                                                    ]
                                                                                                    :
                                                                                                    ticket.status.label === "Closed" && ticket.createdBy.email === user.email ?
                                                                                                        [
                                                                                                            { "label": "Re-Open", "value": "re-open" },
                                                                                                            { "label": "Closed", "value": "closed" }
                                                                                                        ]
                                                                                                        :
                                                                                                        []
                                                                                    )
                                                                                }}>
                                                                                <td valign='middle' className="text-nowrap">{skipEntries + (key + 1)}</td>
                                                                                <td valign='middle' className="text-nowrap">{dayjs(ticket?.deadline).format("YYYY-MM-DD")}</td>
                                                                                <td valign='middle' className="text-nowrap">{dayjs(ticket.updatedAt).format("DD MMM YYYY, h:mma")}</td>
                                                                                <td valign='middle' className="text-nowrap">{ticket.priority?.label}</td>
                                                                                <td valign='middle' className="text-nowrap" style={ticket.createdBy?.uid !== user.uid ? { cursor: "pointer" } : {}}
                                                                                // onClick={() => { if (ticket.createdBy?.uid === user.uid) { } else { setStatusChanger(true); setTicketToUse(ticket); setTicketStatus({ "label": ticket.status?.value, "value": ticket.status?.value }) } }}
                                                                                >
                                                                                    {
                                                                                        ticket.status?.value === "open" ?
                                                                                            <div className='alert alert-secondary p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                {ticket.status?.value}
                                                                                            </div>
                                                                                            :
                                                                                            ticket.status?.value === "in-process" ?
                                                                                                <div className='alert alert-info p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                    {ticket.status?.value}
                                                                                                </div>
                                                                                                :
                                                                                                ticket.status?.value === "closed" ?
                                                                                                    <div className='alert alert-success p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                        {ticket.status?.value}
                                                                                                    </div>
                                                                                                    :
                                                                                                    ticket.status?.value === "reopen" ?
                                                                                                        <div className='alert alert-warning p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                            {ticket.status?.value}
                                                                                                        </div>
                                                                                                        :
                                                                                                        <div className='alert alert-danger p-0 m-0 w-100 rounded-4 fw-bold text-capitalize'>
                                                                                                            {ticket.status?.value}
                                                                                                        </div>
                                                                                    }
                                                                                </td>
                                                                                <td valign='middle'>
                                                                                    <p className="text-start text-nowrap text-truncate w-100 m-0" style={{ maxWidth: "550px" }} title={ticket.subject}>{ticket.subject}</p>
                                                                                </td>
                                                                                <td valign='middle' className='text-nowrap'>
                                                                                    <div className='d-flex flex-wrap justify-content-center gap-2'>
                                                                                        {
                                                                                            ticket.subDepartment?.map((subDep, key) => {
                                                                                                return (
                                                                                                    subDep.label
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                                <td valign='middle' className="text-nowrap" onClick={() => { }}>{ticket.raisedTo?.label}</td>
                                                                                <td valign='middle' className="text-nowrap" title={ticket.createdBy?.email}>{ticket.createdBy?.name}</td>
                                                                                {/* <td valign='middle' className="text-nowrap">YG{ticket.ticketNumber?.toString().padStart(8, '0')}</td> */}
                                                                                {/* <td valign='middle' className="text-nowrap">{ticket.department?.label}</td> */}


                                                                                {/* <td valign='middle' className="text-nowrap">{ticket.description}</td> */}


                                                                                {/* <td valign='middle' className="text-nowrap">
                                                                                    {
                                                                                        ticket.attachments ?
                                                                                            <div className='d-flex align-items-center gap-2' onClick={() => { showAttachmentPreviewNow(ticket.attachments); }} style={{ cursor: "pointer" }}>
                                                                                                <span className="d-flex gap-1 align-items-center" title={ticket.attachments?.name}>
                                                                                                    {
                                                                                                        ticket.attachments?.type?.includes("video") ?
                                                                                                            <MovieIcon />
                                                                                                            :
                                                                                                            ticket.attachments?.type?.includes("image") ?
                                                                                                                <PermMediaIcon />
                                                                                                                :
                                                                                                                ticket.attachments?.type?.includes("audio") ?
                                                                                                                    <AudiotrackIcon />
                                                                                                                    :
                                                                                                                    ticket.attachments?.type?.includes("audio") ?
                                                                                                                        <AudioFileIcon />
                                                                                                                        :
                                                                                                                        ticket.attachments?.type?.includes("video") ?
                                                                                                                            <VideoFileIcon />
                                                                                                                            :
                                                                                                                            ticket.attachments?.type?.includes("pdf") ?
                                                                                                                                <PictureAsPdfIcon />
                                                                                                                                :
                                                                                                                                ""
                                                                                                    }
                                                                                                </span>
                                                                                                <span style={{ fontWeight: "500" }}>
                                                                                                    {
                                                                                                        filesize(ticket.attachments?.size, { "standard": "jedec" })
                                                                                                    }
                                                                                                </span>
                                                                                            </div>
                                                                                            :
                                                                                            ""
                                                                                    }
                                                                                </td> */}

                                                                                {/* <td valign='middle' className="text-nowrap">{ticket.studentId}</td>
                                                                                    <td valign='middle'>
                                                                                        <div className='d-flex flex-wrap justify-content-center gap-2'>
                                                                                            {
                                                                                                ticket.assignedBranch?.map((subDep, key) => {
                                                                                                    return (
                                                                                                        <button key={key} className='btn btn-sm btn-light border'>{subDep.label}</button>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </div>
                                                                                    </td> */}
                                                                                {/* 
                                                                                <td valign='middle' className="text-nowrap">{ticket.deadline}</td>
                                                                                <td valign='middle' className="text-nowrap">{ticket.overdue}</td>
                                                                                <td valign='middle' className="text-nowrap">{ticket.assignedStatus}</td>
                                                                                <td valign='middle' className="text-nowrap">{ticket.assignedTo}</td>
                                                                                <td valign='middle' className="text-nowrap">{ticket.escalationTo}</td> 
                                                                                */}
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr align="center">
                                                                        <td colSpan={19} valign='middle'>No Data</td>
                                                                    </tr>
                                                            }

                                                        </tbody>
                                                    </table>
                                            }
                                        </div>
                                        <div className='w-100 mt-2 customBackgroundFilter rounded'>
                                            <ConfigProvider
                                                theme={{
                                                    components: {
                                                        Pagination: {
                                                            itemActiveBg: "#faf089",
                                                            itemActiveBgDisabled: "yellow",
                                                            // itemActiveColorDisabled: "",
                                                            // itemBg: "",
                                                            // itemInputBg: "",
                                                            // itemLinkBg: "",

                                                        },
                                                    },
                                                    token: {
                                                        // colorBgContainer: "",
                                                        // colorBgContainerDisabled: "",
                                                        // colorBgTextActive: "",
                                                        colorBgTextHover: "rgba(255, 246, 164, 0.73)",
                                                        // colorBorder: "red",
                                                        // colorPrimary: "",
                                                        // colorPrimaryBorder: "#faf089",
                                                        // colorPrimaryHover: "",
                                                        // colorText: "",
                                                        // colorTextDisabled: "",
                                                        // colorTextPlaceholder: "",
                                                        // borderRadius: "",
                                                        // borderRadiusLG: "",
                                                        // borderRadiusSM: "",
                                                        // controlHeight: "",
                                                        // controlOutline: "",
                                                        // controlOutlineWidth: "",
                                                        // fontFamily: "",
                                                        // fontSize: "",
                                                        // lineHeight: "",
                                                        margin: 0,
                                                        // motionDurationMid: "",
                                                        // paddingXXS: ""
                                                    }
                                                }}
                                            >
                                                <Pagination defaultCurrent={2} current={currentPageNumber} defaultPageSize={entriesLimit} showSizeChanger={true} showQuickJumper={true} simple={false} disabled={false} total={totalEntriesCount} onChange={(e) => { setCurrentPageNumber(e); setSkipEntries((e - 1) * entriesLimit) }} onShowSizeChange={(page, pageSize) => { setEntriesLimit(pageSize) }} />
                                            </ConfigProvider>
                                        </div>
                                    </div>
                        }
                    </div>
                    {
                        !logToUse && !showAddNewTicket &&
                        <div className='d-flex flex-column gap-3 h-100 overflow-auto p-4 border cardsTransparent shadow-sm rounded-4 w-100' style={{ maxWidth: "220px" }}>
                            <label>
                                <Autocomplete
                                    disablePortal
                                    onChange={(event, newValues) => { setStatusFilter(newValues) }}
                                    defaultValue={statusFilter}
                                    options={[
                                        { "label": "All Unresolved", "value": "Unresolved" },
                                        { "label": "Open", "value": "open" },
                                        { "label": "Re-Open", "value": "re-open" },
                                        { "label": "Closed", "value": "closed" },
                                        { "label": "In-Process", "value": "in-process" },
                                        { "label": "Invalid", "value": "invalid" }
                                    ]}
                                    sx={{ width: "100%", maxWidth: "250px" }}
                                    multiple={false}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        if (typeof option === 'string') return option;
                                        if (typeof option.label === 'string') return option.label;
                                        return '';
                                    }}
                                    renderInput={(params) => <TextField required {...params} label="Select Status" />}
                                />
                            </label>
                            <label>
                                <Autocomplete
                                    disablePortal
                                    onChange={(event, newValues) => { setPriorityFilter(newValues) }}
                                    options={[
                                        { "label": "Low", "title": "Low", "value": "Low" },
                                        { "label": "Medium", "title": "Medium", "value": "Medium" },
                                        { "label": "High", "title": "High", "value": "High" },
                                    ]}
                                    sx={{ width: "100%", maxWidth: "250px" }}
                                    multiple={false}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        if (typeof option === 'string') return option;
                                        if (typeof option.label === 'string') return option.label;
                                        return '';
                                    }}
                                    renderInput={(params) => <TextField required {...params} label="Select Priority" />}
                                />
                            </label>
                            <label>
                                <Autocomplete
                                    disablePortal
                                    onChange={(event, newValues) => { setAssignedToFilter(newValues) }}
                                    value={assignedToFilter}
                                    options={[{ label: "Not Assigned", value: "Not Assigned" }, ...userOptions]}
                                    sx={{ width: "100%", maxWidth: "250px" }}
                                    multiple={false}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        if (typeof option === 'string') return option;
                                        if (typeof option.label === 'string') return option.label;
                                        return '';
                                    }}
                                    renderInput={(params) => <TextField required {...params} label="Select User" />}
                                />
                            </label>
                            <label>

                                <Autocomplete
                                    disablePortal
                                    onChange={(event, newValues) => { setBranchFilter(newValues) }}
                                    value={branchFilter}
                                    options={[{ label: "All", value: "All" }, ...branchOptions]}
                                    sx={{ width: "100%", maxWidth: "250px" }}
                                    multiple={false}
                                    getOptionLabel={(option) => {
                                        if (!option) return '';
                                        if (typeof option === 'string') return option;
                                        if (typeof option.label === 'string') return option.label;
                                        return '';
                                    }}
                                    renderInput={(params) => <TextField required {...params} label="Select Branch" />}
                                />
                            </label>
                        </div>
                    }
                </div>


            </div>

            {/* ############################### Update Status Panel ############################# */}
            <Modal
                show={statusChanger}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                onHide={() => { setStatusChanger(false); setTicketToUse(null) }}
            >
                <Modal.Header className="py-2" closeButton closeVariant='black'>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className=' d-flex flex-column'>
                            <span style={{ fontSize: "1rem" }}>YG{ticketToUse?.ticketNumber?.toString().padStart(8, '0')}</span>
                            <span style={{ fontSize: "1rem" }}>{ticketToUse?.subject}</span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form action="" className='d-flex flex-column gap-2' onSubmit={(e) => { changeStatusNow(e) }}>
                        <Autocomplete
                            disablePortal
                            required
                            value={ticketStatus}
                            onChange={(event, newValues) => setTicketStatus(newValues)}
                            options={[
                                // { "label": "Open", "value": "open" },
                                { "label": "Re-Open", "value": "re-open" },
                                { "label": "Closed", "value": "closed" },
                                { "label": "In-Process", "value": "in-process" },
                                // { "label": "Invalid", "value": "invalid" }
                            ]}
                            sx={{ width: "100%" }}
                            multiple={false}
                            getOptionLabel={(option) => {
                                if (!option) return '';
                                if (typeof option === 'string') return option;
                                if (typeof option.label === 'string') return option.label;
                                return '';
                            }}
                            renderInput={(params) => <TextField {...params} required label="Status" />}
                        />

                        {/* <label htmlFor='uthaLeImage3' className='m-0'>
                            <img src={AttachmentIcon} alt="" style={{ height: "30px" }} />
                        </label>
                        <input type="file" id="uthaLeImage3" className='form-control w-100 d-none' onInput={(e) => { setattachmentRef(e.target.files[0]) }} /> */}
                        {/* <TextField className='w-100' label="Description" required variant="outlined" onChange={(e) => { setdescriptionRef(e.target.value) }} /> */}

                        <RTE
                            addYoutubeVideoShow={addYoutubeVideoShow}
                            setAddYoutubeVideoShow={setAddYoutubeVideoShow}
                            urlRef={urlRef}
                            videoAdded={videoAdded}
                            editorContent={editorContent}
                            setEditorContent={setEditorContent}
                            isEditable={true}
                            setattachmentRef={setattachmentRef}
                            isDataChanged={isDataChanged}
                            setIsDataChanged={setIsDataChanged}
                            setTags={setTags}
                        />

                        {
                            statusChanged ?
                                <div className='alert alert-success p-1 m-0 w-100 text-center'>
                                    Updated Successfully!
                                </div>
                                :
                                ""
                        }
                        <div className='w-100 d-flex justify-content-center align-items-center'>
                            <button type='submit' className='btn btn-md btn-secondary w-100 rounded-pill' style={{ maxWidth: "130px" }}>Update</button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
            {/* ############################### Update Status Panel End ############################# */}


            {/* ############################### Attachment Preview Panel ############################# */}
            <Modal
                show={showAttachmentPreview}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                onHide={() => { setShowAttachmentPreview(false); setAttachmentToUse(null) }}
            >
                <Modal.Header className="py-2" closeButton closeVariant='black'>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className=' d-flex flex-column'>
                            <span>
                                Attachment Preview
                            </span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex gap-3 flex-column'>
                        <div className='d-flex gap-1'>
                            <span className='text-nowrap fw-bold'>File Name:</span>
                            <span className='text-nowrap text-truncate'>{attachmentToUse?.name}</span>
                        </div>
                        <div className='d-flex gap-1'>
                            <span className='text-nowrap fw-bold'>File Size:</span>
                            <span className='text-nowrap text-truncate'>{filesize(attachmentToUse?.size ? attachmentToUse.size : 0, { "standard": "jedec" })}</span>
                        </div>
                        <div className='d-flex gap-1'>

                            <button className='btn btn-sm btn-outline-success d-flex align-items-center gap-1 rounded-pill p-0'>
                                <DownloadingIcon style={{ fontSize: "2rem" }} onClick={(e) => { saveAs(attachmentToUse?.fileData, attachmentToUse?.name) }} />
                            </button>
                        </div>

                        <div className='m-0 p-0' style={{ background: 'rgba(66, 61, 61, 0.3)', backdropFilter: "blur(3px)" }}>
                            {
                                attachmentToUse ?
                                    attachmentToUse.type?.includes("image") ?
                                        <img src={attachmentToUse.fileData} className='w-100' style={{ aspectRatio: "16/9", objectFit: "contain" }} />
                                        :
                                        attachmentToUse.type?.includes("video") ?
                                            <video src={attachmentToUse.fileData} controls className='w-100' style={{ aspectRatio: "16/9" }}></video>
                                            :
                                            <i className='fa fa-download'>{attachmentToUse.name}</i>
                                    :
                                    <SkeletonTheme
                                        baseColor="rgb(206, 245, 255)"
                                        // highlightColor="#070707a0"
                                        direction="ltr"
                                        duration={2}
                                        customHighlightBackground="linear-gradient(90deg, transparent,rgba(68, 214, 250, 0.63), transparent">
                                        <Skeleton count={1} className='w-100 p-0 m-0' style={{ aspectRatio: "16/9" }} />
                                    </SkeletonTheme>

                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* ############################### Attachment Preview Panel End ############################# */}



            <Modal
                centered
                backdrop="static"
                size='md'
                show={addYoutubeVideoShow}
                onHide={() => { setAddYoutubeVideoShow(false); }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Add YouTube Video
                    </Modal.Title>
                </Modal.Header>

                <form onSubmit={(e) => {
                    e.preventDefault();
                    setVideoAdded(urlRef.current.value)
                    console.log(urlRef.current.value)
                    setAddYoutubeVideoShow(false)
                }}>
                    <Modal.Body>
                        <input type="url" className='form-control' placeholder="Enter Video URL" required ref={urlRef} />
                    </Modal.Body>
                    <Modal.Footer>
                        <input type="submit" value={"Add Video"} />
                    </Modal.Footer>
                </form>
            </Modal>



            {/* ############################### Notification Panel Start ############################# */}
            {
                showToast &&
                <div style={{ position: "fixed", bottom: "5px", right: "5px" }}>
                    <Toast
                        show={showToast}
                        position="bottom-end"
                        onClose={() => {
                            setShowToast(false)
                            setToastType(null)
                            setToastTitle(null)
                            setToastMessage(null)
                        }}
                        delay={2000}
                        autohide
                    // bg={toastType === "error" ? "danger" : toastType === "warning" ? "warning" : toastType === "info" ? "info" : toastType === "success" ? "success" : "success"}
                    >
                        <Toast.Header>
                            <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                            <strong className="me-auto">{toastTitle}</strong>
                            <small>Just Now</small>
                        </Toast.Header>
                        <Toast.Body>{toastMessage}</Toast.Body>
                    </Toast>
                </div>
            }
            {/* ############################### Notification Panel End ############################# */}
        </>
    )
}

export default Ticket